/** The website's part names for Add to Calendar's menu (the piece contract's), passed to the shared CalendarMenu. */
import type { CalendarMenuParts } from '@/components/booking/CalendarMenu';

import { part } from '../contract/runtime';

export const CALENDAR_MENU_PARTS: CalendarMenuParts = {
  trigger: part('addToCalendar'),
  menu: part('calendarMenu'),
  google: part('calendarGoogle'),
  outlook: part('calendarOutlook'),
  apple: part('calendarApple'),
};

/** A piece's calendar choices with its Apple Calendar action. */
export interface WebCalendarChoices {
  readonly google: string;
  readonly outlook: string;
  /** Opens the calendar file (the piece's addToCalendar). */
  readonly download: () => void;
}
